import { lazy } from "react";
import {
  CreditCardOutlined,
  FundViewOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";
import { CiMonitor } from "react-icons/ci";
import ListCard from "../pages/auth/ListCard";
import DetailCard from "../pages/auth/DetailCard";
import Users from "../pages/auth/Users";
import Clients from "../pages/auth/Client";

// Pages
const Dashboard = lazy(() => import("../pages/auth/Dashboard"));

export const MENU_LIST = [
  {
    name: "Dashboard",
    code: "Dashboard",
    icon: <CiMonitor />,
    path: "/dashboard",
    privilege: ["admin", "client"],
    element: <Dashboard />,
  },
  {
    name: "SIM Card",
    code: "SIM Card",
    icon: <CreditCardOutlined />,
    path: "/sim-card",
    privilege: ["admin", "client"],
    element: <ListCard />,
  },
  {
    name: "Detail Card",
    code: "Detail Card",
    icon: <FundViewOutlined />,
    path: "/detail-card",
    privilege: ["admin", "client"],
    element: <DetailCard />,
  },
  {
    name: "Master",
    code: "Master",
    icon: <DatabaseOutlined />,
    path: "/master",
    privilege: ["admin"],
    children: [
      {
        name: "Users",
        code: "Users",
        path: "/master/users",
        privilege: ["admin"],
        element: <Users />,
      },
      {
        name: "Clients",
        code: "Clients",
        path: "/master/clients",
        privilege: ["admin"],
        element: <Clients />,
      },
    ],
  },
];
